import RestrictedPayoutDrivers from "../../services/api/RestrictedPayoutDrivers";
import { setLoader, setStatus } from "./User";
import ActionTypes from "./ActionTypes";
import ErrorMsgs from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import getRestrictedPayoutDriversService from "../../services/api/RestrictedPayoutDrivers";

const handleError = (err) => {
  console.log("[handleError] Error in restricted payout drivers actions", err);
};

export const setRestrictedPayoutDrivers = (payload) => {
  return {
    type: ActionTypes.SET_RESTRICTED_PAYOUT_DRIVERS,
    payload: payload,
  };
};

export const getRestrictedPayoutDrivers = (driverId) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let queryParam = `delivery_driver_id=${driverId}`;
    const response =
      await getRestrictedPayoutDriversService.getRestrictedPayoutDrivers(
        queryParam
      );
    dispatch(setLoader(false));
    if (response) {
      dispatch(setRestrictedPayoutDrivers(response));
      return response;
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : ErrorMsgs.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
